import { render, staticRenderFns } from "./bindImg.vue?vue&type=template&id=6edeb2eb&scoped=true&"
import script from "./bindImg.vue?vue&type=script&lang=js&"
export * from "./bindImg.vue?vue&type=script&lang=js&"
import style0 from "./bindImg.vue?vue&type=style&index=0&id=6edeb2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edeb2eb",
  null
  
)

component.options.__file = "bindImg.vue"
export default component.exports